import Vector2d from '../engine/vector2d';
import Entity from '../entity';
import State from '../state';
import { ChaseMode, Ghost } from './ghost';

export default class Inky extends Ghost {

  getSpriteOffset(): number {
    return 2;
  }

  getGhost(state: State): Entity {
    const [inky] = state.ghosts.filter(g => g.name === 'inky');
    return inky;
  }

  getTarget(mode: ChaseMode, state: State): Vector2d {
    switch (mode) {
      case ChaseMode.Chase:
      case ChaseMode.Frightened:
        return this.getClosestTarget(state);
    }

    return this.getGhost(state).position;
  }
}
